export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40cc02b95f71447b020bc0bfc7049f51bfc44c5627&name=revalidateCommunity!'